import { render, staticRenderFns } from "./FirebaseAccountManagement.vue?vue&type=template&id=2a981096&scoped=true&"
import script from "./FirebaseAccountManagement.vue?vue&type=script&lang=js&"
export * from "./FirebaseAccountManagement.vue?vue&type=script&lang=js&"
import style0 from "./FirebaseAccountManagement.vue?vue&type=style&index=0&id=2a981096&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a981096",
  null
  
)

export default component.exports